import { useTranslations } from "next-intl"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    supplyPoint: graphql(`
        fragment useFormatSupplyPointMarketName_SupplyPoint on SupplyPointType {
            marketName
        }
    `),
}

export function useFormatSupplyPointMarketName() {
    const t = useTranslations("useFormatSupplyPointMarketName")

    return (supplyPoint: FragmentOf<typeof graphQLFragments.supplyPoint>) => {
        const { marketName } = readFragment(graphQLFragments.supplyPoint, supplyPoint)

        return t(`marketName`, {
            marketName,
        })
    }
}

useFormatSupplyPointMarketName.messages = ["useFormatSupplyPointMarketName"] as const

useFormatSupplyPointMarketName.fragments = graphQLFragments
